module.exports = __webpack_public_path__ + "static/project-seldon-c2ed0e003307968bb5d4010262860172.jpg";